import axios from "axios";
import { reducer } from "./redux/store";
import { QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_DATA_LOADER_PROGRESS } from "./redux/app/app.types";
import { PO_DATA_LOADER_PROGRESS } from "./redux/po_backlog/po.types";

const addClientIdInterceptor = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      const client_id = localStorage.getItem("client_id");
      // console.log("intercepting request");
      config.params = config.params || {};
      if (client_id) {
        config.params["client_id"] = client_id;
        config.params["application"] = "qc";
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

const downloadProgressHandler = (event, actionType) => {
  const { estimated, total, loaded, progress } = event;
  const status = { estimated, total, loaded, progress: progress * 100 };
  reducer.dispatch({ type: actionType, payload: status });
};

// Common axios instance
const createAxiosInstance = (baseURL) => {
  const token = localStorage.getItem("token");
  // console.log(token);
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-type": "application/json",
      Authorization: token,
    },
  });
  addClientIdInterceptor(instance);
  return instance;
};

const axiosInstance = createAxiosInstance(
  process.env.REACT_APP_BACKEND_MAIN_URL
);
export default axiosInstance;
export const scheduler = createAxiosInstance(process.env.REACT_APP_BACKEND_URL);

export const scheduler_with_download_progress = createAxiosInstance(
  process.env.REACT_APP_BACKEND_MAIN_URL
);
scheduler_with_download_progress.defaults.onDownloadProgress = (e) =>
  downloadProgressHandler(
    e,
    QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_DATA_LOADER_PROGRESS
  );

export const po_downloader_with_progress = createAxiosInstance(
  process.env.REACT_APP_BACKEND_MAIN_URL
);
po_downloader_with_progress.defaults.onDownloadProgress = (e) =>
  downloadProgressHandler(e, PO_DATA_LOADER_PROGRESS);

export const backlog_downloader_with_progress = createAxiosInstance(
  process.env.REACT_APP_BACKEND_MAIN_URL
);
backlog_downloader_with_progress.defaults.onDownloadProgress = (e) =>
  downloadProgressHandler(e, PO_DATA_LOADER_PROGRESS);
